module.exports = __webpack_public_path__ + "static/media/HAYDIROKET-TRUMINATI.ed9e5b08.png";